<template>
  <v-app class="bg-white">
    <v-overlay :value="loader">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-main class="auth-pages" v-if="company" >

          <div class="footer" id="myHeader" :style="getStyle('footer')">
            <div class="elementor-container elementor-column-gap-default" style="width: 100%;">
              <v-row style="margin:0px!important;">
      <v-col style="padding: 1px;">
					<div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-a828a20" data-id="a828a20" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-88f37c7 elementor-view-default elementor-widget elementor-widget-icon" data-id="88f37c7" data-element_type="widget" data-widget_type="icon.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-wrapper">
			<a class="elementor-icon" :href="'/'">
			<i aria-hidden="true" class="fa fa-id-card" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'"></i>			</a>
		</div>
				</div>
				</div>
				<div class="elementor-element elementor-element-f383dda elementor-widget elementor-widget-heading" data-id="f383dda" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h6 class="elementor-heading-title-card elementor-size-default" ><a :href="'/'" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Card</a></h6>		</div>
				</div>
					</div>
		</div>
    </v-col>
    <v-col style="padding: 1px;">
				<div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-1eed04c" data-id="1eed04c" data-element_type="column" id="share-my-card" @click="overlay = true">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-61dd731 elementor-view-default elementor-widget elementor-widget-icon" data-id="61dd731" data-element_type="widget" data-widget_type="icon.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-wrapper">
			<a class="elementor-icon" href="#">
			<i aria-hidden="true" class="fa fa-qrcode" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'"></i>			</a>
		</div>
				</div>
				</div>
				<div class="elementor-element elementor-element-08fcb6e elementor-widget elementor-widget-heading" data-id="08fcb6e" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h6 class="elementor-heading-title-card elementor-size-default"><a href="#" @click="overlay = true" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Scan</a></h6>		</div>
				</div>
					</div>
		</div>
    </v-col>
    <v-col style="padding: 1px;">
				<div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-d7c2c7a" data-id="d7c2c7a" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-5f80995 elementor-view-default elementor-widget elementor-widget-icon" data-id="5f80995" data-element_type="widget" data-widget_type="icon.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-wrapper">
			<a class="elementor-icon" :href="`tel:${company.phone_m}`">
			<i aria-hidden="true" class="fas fa-phone-alt" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'"></i>			</a>
		</div>
				</div>
				</div>
				<div class="elementor-element elementor-element-2432e95 elementor-widget elementor-widget-heading" data-id="2432e95" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h6 class="elementor-heading-title-card elementor-size-default"><a :href="`tel:${company.phone_m}`" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Direct Call</a></h6>		</div>
				</div>
					</div>
		</div>
    </v-col>
    <v-col v-if="event_value">
				<div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-5b2a404" data-id="5b2a404" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-57f7405 elementor-view-default elementor-widget elementor-widget-icon" data-id="57f7405" data-element_type="widget" data-widget_type="icon.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-wrapper">
			<a class="elementor-icon" :href="event_value" target="_blank">
			<i aria-hidden="true" class="fas fa-calendar-check"></i>			</a>
		</div>
				</div>
				</div>
				<div class="elementor-element elementor-element-eb196fc elementor-widget elementor-widget-heading" data-id="eb196fc" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h6 class="elementor-heading-title-card elementor-size-default"><a :href="event_value" target="_blank">Events</a></h6>		</div>
				</div>
					</div>
		</div>
    </v-col>
    </v-row>
							</div>
          </div>
              <!-- Main Header -->
              <v-app-bar
                elevation="1"
                color="white"
                height="80"
                class="rental-header"
              >
                <v-container class="py-0 fill-height">
                  <v-row align="center" justify="space-between" no-gutters>
                    <v-col cols="auto">
                      <router-link to="/" class="text-decoration-none">
                        <img :height="this.$vuetify.breakpoint.xs ? 80 : 60" class="image-logo2" src="@/assets/img/logo.png">
                      </router-link>
                    </v-col>

                    <v-col cols="auto">
                      <!-- User profile menu for logged-in users -->
                      <v-menu v-if="isLoggedIn" offset-y left min-width="200">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="black"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            elevation="0"
                          >
                            <v-icon size="32" class="material-icons-round">account_circle</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="goToMyBookings">

                            <v-list-item-title>My Bookings</v-list-item-title>
                          </v-list-item>

                          <v-list-item @click="goToProfile">

                            <v-list-item-title>Profile</v-list-item-title>
                          </v-list-item>

                          <v-divider></v-divider>

                          <v-list-item @click="logout">

                            <v-list-item-title>Logout</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <!-- Login button for non-logged-in users -->
                      <v-btn
                        v-else
                        color="#212121"
                        @click="loginDialog = true"
                        rounded
                        elevation="0"
                        class="px-4 text-uppercase font-weight-medium"
                        dark
                        depressed
                        style="height: 36px; border-radius: 20px;"
                      >
                        LOGIN / SIGN UP
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-app-bar>

              <!-- Vehicle Title Section -->
              <v-container class="pt-6 pb-0">
                <!-- Vehicle Title -->
                <v-row class="mb-4">
                  <v-col cols="12" class="mx-auto">
                    <h3 class="text-h4 text-typo font-weight-bold">
                      {{ vehicle.year }} {{vehicle.make}} {{vehicle.model}}
                    </h3>
                  </v-col>
                </v-row>

                <!-- Vehicle Images -->
                <v-row>
                  <v-col cols="12" class="text-center">


                    <VueSlickCarousel
                      ref="c1"
                      v-if="vehicle.images"
                      :asNavFor="$refs.c2"
                      :focusOnSelect="true">
                      <v-img
                      height="250"
                      v-for="(item,i) in vehicle.images"
                          class="w-100 shadow-lg mx-auto"
                          :src="item.image"
                        ></v-img>
                    </VueSlickCarousel>

                    <VueSlickCarousel
                      ref="c2"
                      :asNavFor="$refs.c1"
                      :slidesToShow="4"
                      class="sub-slide"
                      v-if="vehicle.images"
                      :focusOnSelect="true">
                        <v-img
                        height="50"
                        style="margin-right: 5px;"
                      v-for="(item,i) in vehicle.images"
                          class="w-101 shadow-lg mr-2"
                          :src="item.image"
                        ></v-img>
                    </VueSlickCarousel>



                </v-col>
                <v-col lg="12" cols="12">

                  <v-row>
                    <v-col cols="6">
                      <!-- <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="tripStart.date" label="Trip start" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                      </v-menu> -->
                      <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="tripStartDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                 v-model="formattedStartDate"
                                label="Trip Start"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="tripStartDate"
                              no-title
                              color="blue"
                              :allowed-dates="disableBookedDates"
                              :min="minDate"
                              :max="maxDate"
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="blue"
                                @click="menu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="blue"
                                @click="$refs.menu.save(tripStartDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-select v-model="tripStartTime" :items="times" label="Time"></v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="tripEndDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formattedEndDate"
                                label="Trip End"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="tripEndDate"
                              no-title
                              :min="minDate"
                              :max="maxDate"
                              :allowed-dates="disableBookedDates"
                              color="blue"
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="blue"
                                @click="menu2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="blue"
                                @click="$refs.menu2.save(tripEndDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-select v-model="tripEndTime" :items="times" label="Time"></v-select>
                    </v-col>
                  </v-row>
                  <v-divider class="my-3"></v-divider>
                <GmapMap
                    :center="{ lat: parseFloat(vehicle.latitude), lng: parseFloat(vehicle.longitude) }"
                    :zoom="18"
                    map-type-id="terrain"
                    style="width: auto; height: 300px"
                  >
                    <GmapMarker
                      :position="{ lat: parseFloat(vehicle.latitude), lng: parseFloat(vehicle.longitude) }"
                      :clickable="true"
                      :draggable="true"
                    />
                  </GmapMap>
                  <v-divider class="my-3"></v-divider>
                  <v-alert color="green lighten-4" class="mt-3" v-if="discount_rules">
                    <strong>{{ totalDays }}-day discount</strong> <span class="float-right">{{discount_rules.type === 'percentage' ? discount_rules.value + '%' : '$' + discount_rules.value}}</span>
                  </v-alert>
                  <v-divider class="my-3"></v-divider>
                  <v-alert color="blue lighten-4">
                    <strong>Free cancellation</strong>
                    <p class="text-caption">Full refund before Feb 16, 10:00 AM</p>
                  </v-alert>
                  <v-divider class="my-3"></v-divider>
                  <h3 class="text-h6 font-weight-bold d-flex align-center">
                    <span>Booking Price</span>
                    <v-tooltip bottom v-if="vehicle.spin_wheel_assigned">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="#FF9800"
                          class="ml-2 spin-wheel-icon-glow"
                          v-bind="attrs"
                          v-on="on"
                          @click="openSpinWheel"
                        >
                          <img src="@/assets/img/spin.png" alt="Spin Wheel" class="spin-wheel-icon" width="24" height="24">
                        </v-btn>
                      </template>
                      <span>Spin the wheel for discounts!</span>
                    </v-tooltip>
                  </h3>
                  <div class="pa-2 d-flex justify-space-between align-center" outlined>
                    <div>
                      <div v-if="appliedDiscount">
                        <p class="text-h5 font-weight-bold" style="padding-top: 15px;">
                          <span class="text-decoration-line-through mr-2" style="color: #757575; font-size: 0.8em;">
                            ${{ vehicle.rent_price_per_day }}/day
                          </span>
                          <span class="green--text">${{ discountedPrice }}/day</span>
                        </p>
                        <v-chip x-small color="red" class="white--text">
                          <span v-if="appliedDiscount.discountType === 'percentage'">
                            {{ appliedDiscount.value }}% OFF
                          </span>
                          <span v-else>
                            ${{ appliedDiscount.value }} OFF
                          </span>
                        </v-chip>
                      </div>
                      <p v-else class="text-h5 font-weight-bold" style="padding-top: 15px;">
                        <span>${{ vehicle.rent_price_per_day }}/day</span>
                      </p>
                      <!-- <p class="text-caption text-grey">${{ car.totalPrice }} excl. taxes & fees</p> -->
                    </div>
                    <v-btn color="blue" dark class="px-10 py-4" @click="validateBooking">Book</v-btn>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>Distance included</v-list-item-content>
                      <v-list-item-action>{{distance}} mi</v-list-item-action>
                    </v-list-item>
                    <v-divider class="my-3"></v-divider>
                    <v-list-item>
                      <v-list-item-content>Insurance via Travelers</v-list-item-content>
                      <v-list-item-action>
                        <v-icon>mdi-help-circle</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider class="my-3"></v-divider>
                  </v-list>

                    <v-row class="text-center">
                      <v-col cols="3">
                        <img :height="this.$vuetify.breakpoint.xs ? 40 : 40" class="image-logo2" src="@/assets/img/mileage.png">
                        <p>{{ vehicle.mileage }} MPG</p>
                      </v-col>
                      <v-col cols="3">
                        <img :height="this.$vuetify.breakpoint.xs ? 40 : 40" class="image-logo2" src="@/assets/img/fuel.png">
                        <p>{{ vehicle.fuel_type }}</p>
                      </v-col>
                      <v-col cols="3">
                        <img :height="this.$vuetify.breakpoint.xs ? 40 : 40" class="image-logo2 " src="@/assets/img/door.png">
                        <p>{{ vehicle.doors }} doors</p>
                      </v-col>
                      <v-col cols="3">
                        <img :height="this.$vuetify.breakpoint.xs ? 40 : 40" class="image-logo2" src="@/assets/img/seat.png">
                        <p>{{ vehicle.seats }} seats</p>
                      </v-col>
                    </v-row>
                  <v-divider class="my-0"></v-divider>
                  <h3 class="text-h6 font-weight-bold mt-4">More Details</h3>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>Odometer</v-list-item-content>
                      <v-list-item-action>{{ vehicle.odometer }} miles</v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>VIN</v-list-item-content>
                      <v-list-item-action>{{ vehicle.vin }}</v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>Transmission</v-list-item-content>
                      <v-list-item-action>{{ vehicle.transmission }}</v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>Wheeldrive</v-list-item-content>
                      <v-list-item-action>{{ vehicle.wheel_drive }}</v-list-item-action>
                    </v-list-item>
                  </v-list>

                </v-col>
                <!-- <div class="mt-8 ml-3">
                    <Photoswipe>
                      <draggable style="padding: 10px" v-model="vehicle.images" class="v-tabs__container row mt-2" v-if="vehicle.images.length > 0" >
                      <img
                      v-for="(file,n ) in vehicle.images"
                        class="me-2 mb-2"
                        :src="file.image"
                        @click="openGallery(file)"

                      />

                      </draggable>


                    </Photoswipe>
                  </div>
                  -->
              </v-row>
          <v-row style="justify-content: center;margin-bottom: 150px;margin: 0;">
            <!-- <v-col cols="12" md="12" style="">
              <ProfileCards :users="filteredUsers" />
            </v-col> -->
          <v-col cols="12" md="12" style="margin-bottom: 40px !important;">
            <h1 class="text-h6 mt-3 text-center">Powered by <strong>AutoSync</strong></h1>
          </v-col>
          </v-row>
            <v-row style="justify-content: center;margin-bottom:50px!important;"></v-row>

                  <v-dialog
                      v-model="overlay"
                      width="500"
                    >
                    <img v-if="company"  class="" :src="base_url_img+'vcard/'+company.user_id+'-QR.png'" width="50">
                  </v-dialog>

                  <!-- Spinning Wheel Dialog -->
                  <v-dialog
                      v-model="spinWheelDialog"
                      max-width="700"
                      persistent
                    >
                    <div>
                      <v-card-title class="text-h5 d-flex justify-space-between align-center">
                        <span>{{ wheelSettings.title }}</span>
                        <v-btn icon @click="closeSpinWheel">
                          <v-icon class="material-icons-round me-sm-1" size="20">close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="vehicle" class="text-center mb-4">
                          <h3>{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</h3>
                          <p>Spin the wheel to win discounts for this vehicle!</p>
                          <div v-if="remainingSpins > 0" class="mt-2">
                            <v-chip color="success" outlined>
                              <v-icon left>mdi-refresh</v-icon>
                              {{ remainingSpins }} spins remaining
                            </v-chip>
                          </div>
                          <div v-else class="mt-2">
                            <v-chip color="red" outlined>
                              No spins remaining
                            </v-chip>
                          </div>
                        </div>

                        <div v-if="loadingWheel" class="text-center py-5">
                          <clip-loader :loading="loadingWheel" color="#FF9800" size="50px"></clip-loader>
                          <p class="mt-4">Loading wheel...</p>
                        </div>

                        <div v-else-if="wheelSegments.length > 0" class="text-center py-3">
                          <SpinningWheel
                            :segments="wheelSegments"
                            :colors="wheelColors"
                            :isSpinning="spinInProgress"
                            :spinDuration="wheelSettings.spinDuration"
                            :canSpin="remainingSpins > 0"
                            @prize-won="handleSpinComplete"
                          />
                        </div>

                        <div v-if="currentPrize" class="text-center mt-4 pa-3 prize-result">
                          <!-- Show different header based on prize type or content -->
                          <h2 v-if="currentPrize.type === 'try_again' || (currentPrize.label && currentPrize.label.includes('Try Again'))" class="text-h4 font-weight-bold">Better luck next time!</h2>
                          <h2 v-else class="text-h4 font-weight-bold">Congratulations!</h2>

                          <!-- Try Again result -->
                          <div v-if="currentPrize.type === 'try_again' || (currentPrize.label && currentPrize.label.includes('Try Again'))">
                            <h3 class="text-h5 mt-2">
                              <v-icon large color="error">mdi-refresh</v-icon>
                              Try Again
                            </h3>
                            <p class="mt-2">Don't worry, you'll have better luck next time!</p>
                            <p v-if="remainingSpins > 0" class="mt-2">You still have {{ remainingSpins }} spin(s) remaining.</p>
                          </div>

                          <!-- Discount prize -->
                          <div v-else-if="currentPrize.type === 'discount'">
                            <h3 class="text-h5 mt-2">
                              <v-icon large color="success">mdi-tag-outline</v-icon>
                              <span v-if="currentPrize.discountType === 'percentage'">
                                {{ currentPrize.value }}% OFF
                              </span>
                              <span v-else>
                                ${{ currentPrize.value }} OFF
                              </span>
                            </h3>
                            <p class="mt-2">Discount code: <strong>{{ currentPrize.code }}</strong></p>
                            <p>This discount has been automatically applied to your booking!</p>
                          </div>

                          <!-- Gift card prize -->
                          <div v-else-if="currentPrize.type === 'gift_card'">
                            <h3 class="text-h5 mt-2">
                              <v-icon large color="success">mdi-gift-outline</v-icon>
                              ${{ currentPrize.value }} Gift Card
                            </h3>
                            <p class="mt-2">Code: <strong>{{ currentPrize.code }}</strong></p>
                          </div>

                          <!-- Points prize -->
                          <div v-else-if="currentPrize.type === 'points'">
                            <h3 class="text-h5 mt-2">
                              <v-icon large color="success">mdi-star-outline</v-icon>
                              {{ currentPrize.value }} Points
                            </h3>
                            <p class="mt-2">Added to your account!</p>
                          </div>

                          <!-- Custom prize -->
                          <div v-else-if="currentPrize.type === 'custom'">
                            <h3 class="text-h5 mt-2">
                              <v-icon large color="success">mdi-trophy-outline</v-icon>
                              Special Prize!
                            </h3>
                            <p class="mt-2">{{ currentPrize.description }}</p>
                          </div>
                        </div>

                        <v-alert v-if="!isLoggedIn" type="warning" class="mt-4">
                          You need to be logged in to use the spinning wheel and claim your prizes.
                        </v-alert>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!isLoggedIn" color="blue" @click="goToLogin" dark>
                          Login / Sign Up
                        </v-btn>
                        <!-- <v-btn
                          v-else-if="!currentPrize"
                          color="green"
                          dark
                          :disabled="spinInProgress || loadingWheel || remainingSpins <= 0"
                          @click="spinTheWheel"
                        >
                          <v-icon left class="material-icons-round">rotate_right</v-icon>
                          {{ remainingSpins > 0 ? 'Spin Now' : 'No Spins Left' }}
                        </v-btn> -->
                        <v-btn
                          v-else-if="currentPrize"
                          :color="isTryAgainPrize ? 'blue' : 'primary'"
                          dark
                          @click="isTryAgainPrize && remainingSpins > 0 ? spinTheWheel() : closeSpinWheel()"
                        >
                          {{ isTryAgainPrize ? (remainingSpins > 0 ? 'Try Again' : 'Continue Booking') : 'Continue Booking' }}
                        </v-btn>
                        <v-btn
                          v-else
                          color="error"
                          outlined
                          @click="closeSpinWheel"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </div>
                  </v-dialog>
                  <v-dialog
                      v-model="bookingConfirmDialog"
                      width="500"
                    >
                    <div>
                      <v-card-title class="headline" style="display: block;text-align: center;">🎉 Congratulations!</v-card-title>
                      <v-card-text style="text-align: center;">
                        Thank you for your booking. <br />
                        Check your email for more details.
                      </v-card-text>
                      <v-card-actions style="justify-content: center;">
                        <div style="width: 100%;justify-content: center;display: flex">
                        <v-btn  text @click="bookingConfirmDialog = false">OK</v-btn>
                      </div>
                      </v-card-actions>
                    </div>


                  </v-dialog>
                  <v-dialog v-model="bookingDialog" max-width="500px">
                    <div>
                      <v-card-title class="text-h6">Confirm Your Booking</v-card-title>
                      <v-card-text>
                        <p><strong>Car:</strong> {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</p>
                        <p><strong>Booking Period:</strong> {{ tripStartDate }} {{ tripStartTime }} - {{ tripEndDate }} {{ tripEndTime }}</p>
                        <p><strong>Base Price:</strong> ${{ totalAmount }}</p>

                        <!-- Display applied coupon -->
                        <div v-if="appliedDiscount" class="applied-coupon pa-2 mb-2">
                          <div class="d-flex align-center">
                            <v-icon color="success" class="mr-2">mdi-tag-outline</v-icon>
                            <div>
                              <strong>Applied Coupon:</strong>
                              <span v-if="appliedDiscount.discountType === 'percentage'">
                                {{ appliedDiscount.value }}% OFF
                              </span>
                              <span v-else>
                                ${{ appliedDiscount.value }} OFF
                              </span>
                              <div class="caption grey--text">Code: {{ appliedDiscount.code }}</div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn x-small text color="red" @click="removeDiscount">
                              <v-icon small class="material-icons-round">close</v-icon>
                            </v-btn>
                          </div>
                        </div>

                        <!-- Spin to win button -->
                        <div v-if="!appliedDiscount && isLoggedIn" class="text-center my-3">
                          <v-btn
                            color="amber"
                            @click="openSpinWheel"
                            class="spin-button"
                            :disabled="remainingSpins <= 0"
                          >
                            <v-icon left class="material-icons-round">rotate_right</v-icon>
                            Spin to Win a Discount
                          </v-btn>
                          <div class="caption mt-1" v-if="remainingSpins > 0">
                            You have {{ remainingSpins }} free spins remaining
                          </div>
                          <div class="caption mt-1 red--text" v-else>
                            No spins remaining
                          </div>
                        </div>

                        <!-- Display discount breakdown -->
                        <div v-if="calculatedDiscountAmount > 0" class="discount-breakdown mb-2">
                          <p class="mb-1"><strong>Discounts:</strong></p>

                          <!-- Coupon discount -->
                          <div v-if="appliedDiscount" class="ml-3 mb-1 d-flex">
                            <span>Coupon discount:</span>
                            <v-spacer></v-spacer>
                            <span class="green--text">
                              -{{ appliedDiscount.discountType === 'percentage' ?
                                `${appliedDiscount.value}% (${(totalAmount * appliedDiscount.value / 100).toFixed(2)}$)` :
                                `$${appliedDiscount.value}` }}
                            </span>
                          </div>

                          <!-- Discount rules -->
                          <div v-if="discount_rules" class="ml-3 mb-1 d-flex">
                            <span>Additional discount:</span>
                            <v-spacer></v-spacer>
                            <span class="green--text">
                              -{{ discount_rules.type === 'percentage' ?
                                `${discount_rules.value}%` :
                                `$${discount_rules.value}` }}
                            </span>
                          </div>

                          <!-- Total discount -->
                          <div class="mt-1 d-flex font-weight-medium">
                            <span>Total discount:</span>
                            <v-spacer></v-spacer>
                            <span class="green--text">-${{ calculatedDiscountAmount }}</span>
                          </div>
                        </div>

                        <p><strong>Total Amount:</strong> <span class="text-h5 font-weight-bold">${{ finalAmount }}</span></p>

                        <!-- User information section - only shown if not logged in -->
                        <div v-if="!isLoggedIn">
                          <v-text-field v-model="user.first_name" label="First Name" required></v-text-field>
                          <v-text-field v-model="user.last_name" label="Last Name" required></v-text-field>
                          <v-text-field v-model="user.email" label="Email" type="email" required ></v-text-field>
                          <v-text-field v-model="user.phone" label="Phone" type="tel" required v-mask="'(###) ###-####'"></v-text-field>
                        </div>

                        <!-- No user details shown when logged in -->

                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  text @click="bookingDialog = false">Cancel</v-btn>
                        <v-btn color="green"  dark @click="bookCar" :loading="loadingSaveButton">Book Now</v-btn>
                      </v-card-actions>
                    </div>
                  </v-dialog>

                  <!-- Login/Signup Dialog -->
                  <v-dialog v-model="loginDialog" max-width="500px">
                    <div style="background-color: white;">
                      <v-card-title class="text-h5">
                        {{ isLogin ? 'Login' : 'Sign Up' }}
                      </v-card-title>

                      <v-card-text>
                        <p class="mb-4">You need to {{ isLogin ? 'login' : 'sign up' }} before booking a vehicle.</p>

                        <!-- Login Form -->
                        <v-form v-if="isLogin" ref="loginForm" v-model="loginValid" @submit.prevent="login">
                          <v-text-field
                            v-model="loginData.email"
                            label="Email"
                            type="email"
                            :rules="emailRules"
                            required
                            outlined
                            dense
                          ></v-text-field>

                          <v-text-field
                            v-model="loginData.password"
                            label="Password"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showPassword = !showPassword"
                            :rules="passwordRules"
                            required
                            outlined
                            dense
                          ></v-text-field>

                          <div class="d-flex justify-space-between align-center mb-4">
                            <a href="#" class="text-decoration-none" @click.prevent="forgotPassword = true; loginDialog = false">
                              Forgot password?
                            </a>
                          </div>
                        </v-form>

                        <!-- Register Form -->
                        <v-form v-else ref="registerForm" v-model="registerValid" @submit.prevent="register">
                              <v-text-field
                                v-model="registerData.first_name"
                                label="First Name"
                                :rules="nameRules"
                                required
                                outlined
                                dense
                              ></v-text-field>

                              <v-text-field
                                v-model="registerData.last_name"
                                label="Last Name"
                                :rules="nameRules"
                                required
                                outlined
                                dense
                              ></v-text-field>
                          <v-text-field
                            v-model="registerData.email"
                            label="Email"
                            type="email"
                            :rules="emailRules"
                            required
                            outlined
                            dense
                          ></v-text-field>

                          <v-text-field
                            v-model="registerData.phone"
                            label="Phone"
                            :rules="phoneRules"
                            required
                            outlined
                            dense
                            v-mask="'(###) ###-####'"
                          ></v-text-field>
                        </v-form>

                        <v-alert v-if="authError" type="error" class="mt-4">
                          {{ authError }}
                        </v-alert>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn text @click="loginDialog = false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text @click="isLogin = !isLogin" >
                          {{ isLogin ? 'Sign Up Instead' : 'Login Instead' }}
                        </v-btn>
                        <v-btn
                          color="green"
                          dark
                          @click="isLogin ? login() : register()"
                          :loading="authLoading"
                        >
                          {{ isLogin ? 'Login' : 'Sign Up' }}
                        </v-btn>
                      </v-card-actions>
                    </div>
                  </v-dialog>

                  <!-- Forgot Password Dialog -->
                  <v-dialog v-model="forgotPassword" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">Reset Password</v-card-title>

                      <v-card-text>
                        <p class="mb-4">Enter your email address and we'll send you a link to reset your password.</p>

                        <v-text-field
                          v-model="forgotPasswordEmail"
                          label="Email"
                          type="email"
                          :rules="emailRules"
                          required
                          outlined
                          dense
                        ></v-text-field>

                        <v-alert v-if="forgotPasswordError" type="error" class="mt-4">
                          {{ forgotPasswordError }}
                        </v-alert>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="forgotPassword = false">Cancel</v-btn>
                        <v-btn color="primary" @click="resetPassword" :loading="resetLoading">
                          Reset Password
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-container>
              </v-main>
  </v-app>
</template>
<script>
var slides = document.querySelectorAll(".slide");
var currentSlide = 0;


import AppBarBlurAuth from "@/components/AppBarBlurAuth";
import VCard from 'vcard-creator'
import { FadeTransition } from "vue2-transitions";
import Query from "@/components/Forms/Query.vue";
import ProfileCards from "@/components/Forms/VehicleCardList.vue";
import VueSlickCarousel from 'vue-slick-carousel'
// import { GmapMap, GmapMarker } from 'vue2-google-maps';
import Chart from "chart.js/auto";
  // optional style for arrows & dots
   import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { max, min } from "moment";
import SpinningWheel from '@/components/Games/SpinningWheel.vue';
import ClipLoader from 'vue-spinner/src/PulseLoader.vue';
export default {

  name: "page-layout",
  components: {
    AppBarBlurAuth,
    FadeTransition,
    ProfileCards,
    VCard,
    Query,
    VueSlickCarousel,
    SpinningWheel,
    'clip-loader': ClipLoader,
    // GmapMap,
    // GmapMarker
  },
  data() {
    return {
       checkbox: false,
       showpassword : false,
       email : '',
      password : '',
      menu: false,
      menu2: false,
      sales_agent_count: 0,
      bookingDialog: false,
      search_rep: '',
      discount_rules: '',
      booked_dates: [],
      minDate : new Date().toISOString().substr(0, 10),
      maxDate :new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().substr(0, 10),
      ref_agent_count: 0,
      distance: 0,
      user:{
        first_name: "",
        last_name: "",
        email: "",
        phone: ""
      },
      calculator: {
        down_payment: 0,
        total_amount: 0,
        trade_in: 0,
        credit_range: '781 - 850',
        interest_rate: 0,
        tenure: 3
      },
      tripStartDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      tripStartTime: "10:00 AM",
      formattedStartDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      tripEndDate: (new Date(Date.now() + 3 * 24 * 60 * 60 * 1000 - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      formattedEndDate: (new Date(Date.now() + 3 * 24 * 60 * 60 * 1000 - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      tripEndTime: "10:00 AM",
      pickupLocation: "New York Stewart International Airport",
      locations: ["New York Stewart International Airport", "JFK Airport", "LAX Airport"],
      times: ["12 AM","12:30 AM","1:00 AM","1:30 AM","2:00 AM","2:30 AM","3:00 AM","3:30 AM","4:00 AM","4:30 AM","5:00 AM","5:30 AM","6:00 AM","6:30 AM","7:00 AM","7:30 AM","8:00 AM","8:30 AM","9:00 AM","9:30 AM", "10:00 AM","10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM","8:30 PM","9:00 PM","9:30 PM","10:00 PM","10:30 PM","11:00 PM","11:30 PM"],
      phone : '',
      loader : true,
      background: '',
      tab_card:'',
      spinWheelDialog: false,
      spinInProgress: false,
      wheelSegments: [],
      wheelColors: [],
      segmentData: [],
      remainingSpins: 0,
      loadingDiscount: false,
      savedCoupons: [],
      appliedDiscount: null,
      wheelSettings: {
        title: 'Spin to Win',
        spinDuration: 5,
        spinLimit: 1,
        spinLimitPeriod: 'day',
        requireLogin: true,
        active: true
      },
      currentPrize: null,
      loadingWheel: false,
      appliedDiscount: null,
      savedCoupons: [],
      calculatedDiscount: 0,
      calculatedDiscountAmount: 0,

      // Authentication related properties
      loginDialog: false,
      isLogin: true,
      loginValid: false,
      registerValid: false,
      authLoading: false,
      authError: null,
      showPassword: false,
      forgotPassword: false,
      forgotPasswordEmail: '',
      forgotPasswordError: null,
      resetLoading: false,

      loginData: {
        email: '',
        password: ''
      },

      registerData: {
        first_name: '',
        last_name: '',
        email: '',
        phone: ''
      },

      // Validation rules
      nameRules: [
        v => !!v || 'Name is required'
      ],

      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid'
      ],

      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Password must be at least 6 characters'
      ],

      phoneRules: [
        v => !!v || 'Phone number is required',
        v => v.replace(/\D/g, '').length === 10 || 'Phone number must be valid'
      ],
      vimeo_account: '',
      vimeo_id : '',
      reps_flag : false,
      company_settings : '',
      total_loan_amount: 0,
      monthly_payment: 0,
      total_interest: 0,
      reps_users : [],
      overlay : false,
      index: 0,
      showPassword : false,
      zoom_value : '',
      base64Image :'',
      avatar_mimeType: '',
      event_value :'',
      dialog: false,
      bookingConfirmDialog : false,
      color : '',
      videos : [],
      loadingSaveButton : false,
      tab: 'tab-1',
      vehicle: {},
      settings: { "centerPadding": "20px",  arrows: true,
      dots: true,},
      pageFlag: 'init',
      backgroundLogo: localStorage.getItem('admin_bg'),
      isDark :true,
      buttonFlag   : false,
      loadingLogo : false,
      url : '',
      items: [
        ],
      company : '',
      vcard : '',
      loadingFlag : false,
      base_url_img : process.env.VUE_APP_WASBI_URL,
      pageTitle: ''
    };
  },
  beforeCreate: function () {

},
created: function () {
      const domain = this.getSubdomain();
      this.getSettings()
      if(domain){
        this.getCompanyInfo(domain)
      }else
        this.$router.push('/login');


},
mounted : function () {
  this.getUserLocation();
  this.formatDate(this.tripStartDate);
  this.formatDate2(this.tripEndDate);

  // Load saved coupons when the page loads

},
methods: {
  // Profile menu methods
  goToMyBookings() {
    // Redirect to the bookings page
    window.location.href = '/rental/bookings';
  },

  goToProfile() {
    // Redirect to the profile page
    window.location.href = '/rental/profile';
  },

  logout() {
    // Clear user data from localStorage
    localStorage.removeItem('rental_token');
    localStorage.removeItem('rental_user');

    // Show success message
    Vue.$toast.success('Logged out successfully', {
      position: 'top-right',
    });

    // Refresh the page
    window.location.reload();
  },

  prevSlide(index) {
  if(index !=0 )
    this.index = index - 1;
  else
    this.index = this.videos.length - 1;

},
getDatesBetween(start, end) {
  let dates = [];
  let currentDate = new Date(start);
  let endDate = new Date(end);

  while (currentDate <= endDate) {
    dates.push(currentDate.toISOString().split("T")[0]); // Format: YYYY-MM-DD
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
},
validateBooking() {
  const startDate = new Date(this.tripStartDate);
  const endDate = new Date(this.tripEndDate);

  if (endDate <= startDate) {
    Vue.$toast.error("End date must be after start date!", {
      position: "top-right",
    });
    return;
  }

  // ✅ Convert date range into an array of dates
  const selectedDates = this.getDatesBetween(this.tripStartDate, this.tripEndDate);

  // ✅ Check if any selected date is already booked
  const isOverlapping = selectedDates.some(date => this.booked_dates.includes(date));

  if (isOverlapping) {
    Vue.$toast.error("Selected dates overlap with an existing booking!", {
      position: "top-right",
    });
    return;
  }

  // Check if user is logged in
  if (this.isLoggedIn) {
    // User is logged in, proceed with booking

    // Get user info from localStorage
    const userData = JSON.parse(localStorage.getItem('rental_user'));
    if (userData) {
      this.user.first_name = userData.first_name;
      this.user.last_name = userData.last_name;
      this.user.email = userData.email;
      this.user.phone = userData.phone_m || '';
    }

    // Load saved coupons and check if any apply to this vehicle
    this.loadSavedCoupons();

    // Open booking dialog
    this.bookingDialog = true;
  } else {
    // User is not logged in, show login dialog
    this.loginDialog = true;
  }
},

// Authentication methods
login() {
  // Validate fields first
  if (!this.loginData.email || !this.loginData.password) {
    this.authError = 'Email and password are required';
    return;
  }

  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(this.loginData.email)) {
    this.authError = 'Please enter a valid email address';
    return;
  }

  this.authError = null;
  this.authLoading = true;

  // Make sure we're using the correct API endpoint with the full URL
  window.axios.post('/api/auth/rental/login', {
    email: this.loginData.email,
    password: this.loginData.password
  })
  .then(response => {
    if (response.data.flag === 1) {
      // Save token and user data
      localStorage.setItem('rental_token', response.data.token.token);
      localStorage.setItem('rental_user', JSON.stringify(response.data.data));

      // Check if rental role was added
      if (response.data.role_added) {
        Vue.$toast.success('Rental customer role has been added to your account.', {
          position: 'top-right',
        });
      }

      // Close login dialog and open booking dialog
      this.loginDialog = false;

      // Set user info for booking
      const userData = response.data.data;
      this.user.first_name = userData.first_name;
      this.user.last_name = userData.last_name;
      this.user.email = userData.email;
      this.user.phone = userData.phone_m || '';
      this.user.user_id = userData.user_id;

      // Load saved coupons
      this.loadSavedCoupons();
      this.loadWheelConfig();

      // Open booking dialog
      this.bookingDialog = true;
    } else {
      this.authError = response.data.message || 'Login failed. Please check your credentials.';
    }
  })
  .catch(error => {
    console.error('Login error:', error);
    this.authError = error.response?.data?.message || 'An error occurred during login. Please try again.';
  })
  .finally(() => {
    this.authLoading = false;
  });
},

register() {
  // Validate fields first
  if (!this.registerData.first_name || !this.registerData.last_name || !this.registerData.email || !this.registerData.phone) {
    this.authError = 'All fields are required';
    return;
  }

  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(this.registerData.email)) {
    this.authError = 'Please enter a valid email address';
    return;
  }

  // Validate phone number (must be 10 digits after removing non-digits)
  const phoneDigits = this.registerData.phone.replace(/\D/g, '');
  if (phoneDigits.length !== 10) {
    this.authError = 'Please enter a valid 10-digit phone number';
    return;
  }

  this.authError = null;
  this.authLoading = true;

  // Make sure we're using the correct API endpoint
  window.axios.post('/api/auth/rental/register', {
    first_name: this.registerData.first_name,
    last_name: this.registerData.last_name,
    email: this.registerData.email,
    phone: this.registerData.phone.replace(/\D/g, '')
  })
  .then(response => {
    if (response.data.flag === 1) {
      // Check if user is new or existing
      if (response.data.is_new_user) {
        // New user - show success dialog with clear instructions
        this.loginDialog = false;

        // Show success dialog with detailed instructions
        this.$swal({
          title: 'Registration Successful!',
          html: `
            <div class="text-left">
              <p><strong>A temporary password has been sent to your email:</strong> ${this.registerData.email}</p>
              <p>Please check your inbox (and spam folder) for an email with your temporary password.</p>
              <p>You need to login with this temporary password to continue with your booking.</p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Login Now',
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            // Switch to login form with email pre-filled
            this.isLogin = true;
            this.loginData.email = this.registerData.email;
            this.loginDialog = true;
          }
        });

        // Also show toast notification
        Vue.$toast.success('Registration successful! Check your email for your temporary password.', {
          position: 'top-right',
        });
      } else {
        // This case shouldn't happen with the updated backend, but keeping it for safety
        // Existing user with rental role added
        if (response.data.role_added) {
          Vue.$toast.success('Rental customer role has been added to your existing account.', {
            position: 'top-right',
          });
        }

        // Redirect to login form
        this.loginDialog = false;
        this.isLogin = true;
        this.loginData.email = this.registerData.email;
        this.loginDialog = true;
      }
    } else if (response.data.flag === 2) {
      // User exists - show dialog with instructions
      this.loginDialog = false;

      // Show dialog with instructions for existing users
      this.$swal({
        title: 'Account Already Exists',
        html: `
          <div class="text-left">
            <p>An account with this email already exists.</p>
            <p>Please use the login form with your existing password or use the "Forgot Password" option if you don't remember it.</p>
          </div>
        `,
        icon: 'info',
        confirmButtonText: 'Login Now',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          // Switch to login form with email pre-filled
          this.isLogin = true;
          this.loginData.email = this.registerData.email;
          this.loginDialog = true;
        }
      });
    } else {
      this.authError = response.data.message || 'Registration failed. Please try again.';
    }
  })
  .catch(error => {
    console.error('Registration error:', error);
    this.authError = error.response?.data?.message || 'An error occurred during registration. Please try again.';
  })
  .finally(() => {
    this.authLoading = false;
  });
},

resetPassword() {
  // Validate email field
  if (!this.forgotPasswordEmail) {
    this.forgotPasswordError = 'Email is required';
    return;
  }

  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(this.forgotPasswordEmail)) {
    this.forgotPasswordError = 'Please enter a valid email address';
    return;
  }

  this.forgotPasswordError = null;
  this.resetLoading = true;

  // Make sure we're using the correct API endpoint
  window.axios.post('/api/auth/rental/reset-password', {
    email: this.forgotPasswordEmail
  })
  .then(response => {
    if (response.data.flag === 1) {
      this.forgotPassword = false;
      Vue.$toast.success('Password reset email sent. Please check your inbox.', {
        position: 'top-right',
      });
      this.forgotPasswordEmail = '';
    } else {
      this.forgotPasswordError = response.data.message || 'Password reset failed. Please try again.';
    }
  })
  .catch(error => {
    console.error('Password reset error:', error);
    this.forgotPasswordError = error.response?.data?.message || 'An error occurred. Please try again.';
  })
  .finally(() => {
    this.resetLoading = false;
  });
},
  bookCar(){
    // here write api call to book car
    let flag = 1;

    // Check if user is logged in
    if (!this.isLoggedIn) {
      // If not logged in, show login dialog
      this.loginDialog = true;
      return;
    }

    // Get user data from localStorage
    const userData = JSON.parse(localStorage.getItem('rental_user'));
    if (!userData || !userData.user_id) {
      Vue.$toast.error('User information not found. Please login again.', {
        position: 'top-right'
      });
      this.loginDialog = true;
      return;
    }

    // Prepare booking data
    const bookingData = {
      user_id: userData.user_id,
      startDate: this.tripStartDate,
      endDate: this.tripEndDate,
      startTime: this.tripStartTime,
      endTime: this.tripEndTime,
      vehicle_id: this.vehicle.id,
      discount_amount: this.calculatedDiscountAmount,
      total_amount: this.finalAmount,
      // Include discount information
      discounts: {
        // Include coupon discount if available
        coupon: this.appliedDiscount ? {
          type: this.appliedDiscount.type,
          discount_type: this.appliedDiscount.discountType,
          value: this.appliedDiscount.value,
          code: this.appliedDiscount.code
        } : null,
        // Include discount rules if available
        rules: this.discount_rules ? {
          type: this.discount_rules.type,
          value: this.discount_rules.value
        } : null,
        // Total discount amount
        total_amount: parseFloat(this.calculatedDiscountAmount)
      }
    };

    // For non-logged in users (this shouldn't happen as we require login, but keeping as a fallback)
    if (!this.isLoggedIn) {
      // Redirect to login
      this.loginDialog = true;
      return;
    }

    if (flag == 1) {
      this.loadingSaveButton = true;
      this.isDark = false;
      this.isDisable = true;

      // Get the rental token
      const token = localStorage.getItem('rental_token');

      window.axios({
        method: "POST",
        url: "/api/auth/rental/book-rental-vehicle",
        data: bookingData,
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Authorization': `Bearer ${token}`
        }
                })
                .then(response => {
                    if(response.data.flag){

                            this.isDark = true;
                            this.isDisable = false;
                            this.loadingSaveButton = false;
                            this.user = {
                                first_name: "",
                                last_name: "",
                                email: "",
                                phone: ""
                              };
                              this.bookingDialog = false;
                              this.bookingConfirmDialog = true;

                      }
                })
                .catch(err => {
                  console.log(err);
                    // console.log(JSON.parse(err.response.data));
                    this.isDark = true;
                    this.isDisable = false;
                    this.loadingSaveButton = false;

                });

            }
  },
nextSlide(index) {
  if(index != this.videos.length - 1 )
    this.index = index + 1
  else
    this.index = 0
},
gotopayemnt: function () {
    let self = this;
    self.$router.push('/card-payment/'+this.$route.params.id);
},
getUserLocation() {
      if (localStorage.getItem('userLocation')) {
        const storedLocation = JSON.parse(localStorage.getItem('userLocation'));
        this.calculateDistance(parseFloat(storedLocation.latitude), parseFloat(storedLocation.longitude));
      } else if (window.isSecureContext && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            localStorage.setItem('userLocation', JSON.stringify({ lat: userLat, lng: userLng }));
            this.calculateDistance(userLat, userLng);
          },
          error => {
            this.geoError = "Geolocation request denied. Please enable location access.";
          }
        );
      } else {
        this.geoError = "Geolocation requires HTTPS. Please access the site securely.";
      }
  },
  calculateDistance(lat, lng) {
      const toRad = (angle) => (angle * Math.PI) / 180;
      const R = 3958.8; // Radius of the Earth in miles
      const lat1 = parseFloat(this.vehicle.latitude);
      const lon1 = parseFloat(this.vehicle.longitude);
      const lat2 = lat;
      const lon2 = lng;

      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
          Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      this.distance = (R * c).toFixed(2);
    },
checkSocial(social){
  if(!this.company.social_flags)
    return true;
  let social_flags = JSON.parse(this.company.social_flags);
  if(social_flags[social] == 1)
    return true;
  return false;
},
formatDate(date) {
      if (date) {
        const [year, month, day] = date.split('-');
        this.formattedStartDate = `${month}/${day}/${year}`;
      }
    },
  formatDate2(date) {
      if (date) {
        const [year, month, day] = date.split('-');
        this.formattedEndDate = `${month}/${day}/${year}`;
      }
  },
getSubdomain() {
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');

    // Assuming the domain is of the form subdomain.example.com
    // Exclude 'www' as a subdomain
    if (domainParts.length > 2 && domainParts[0] !== 'www') {
        return domainParts[0];
    } else {
        return null; // No subdomain
    }
}
,
 getInventory(id){

  axios({
          method: "POST",

          url: "/api/get-inventory-user",
          data: {
            id: id
          }

        })
          .then(async(response) => {
            if(response.data.flag == 1){
                this.reps_users = response.data.user;
                this.reps_flag = true;
                this.loader = false

            }else{
              this.$router.push('/login');
            }
          })

},
async copyURL() {
  console.log(window.location);
      try {
        await navigator.clipboard.writeText(window.location);
        alert('URL Copied, Now you can share the URL');
      } catch($e) {
        alert('Cannot copy');
      }
    },
checkFormSignup(){
  let flag = 1;
      if (!this.email) {
        Vue.$toast.error('Email is required', {
            position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
      }
      if (!this.password && flag == 1) {
        Vue.$toast.error('Password is required', {
            position: 'top-right'
        });
        this.$refs['password'].focus()
        flag = 0;
      }

      if (flag == 1) {
        localStorage.setItem('temp_email',this.email)
        localStorage.setItem('temp_pass',this.password)
        localStorage.setItem('email_verified',0)
        if(this.company)
          this.$router.push('/signup/'+this.url)
        else
          this.$router.push('/signup')
      }
},
getStyle(flag){
  let self = this;
  let color = this.vcard.color;
  let font = this.vcard.header_color;
  let color_code = '';
  const colorArray = [
  { name: 'Orange', code: '#FD7E14' },
  { name: 'Green', code: '#28A745' },
  { name: 'Purple', code: '#6F42C1' },
  { name: 'Red', code: '#DC3545' },
  { name: 'Pink', code: '#E83E8C' },
  { name: 'Blue', code: '#007BFF' },
  { name: 'Dark Blue', code: '#0033cc' },
  { name: 'Black', code: '#000000' },
  { name: 'Silver', code: '#C0C0C0' },
  { name: 'Hot Pink', code: '#FF69B4' },
  { name: 'Flat Black', code: '#2D3436' }
];
colorArray.forEach(element => {
  if(element.name == color){
    color_code = element.code;
    self.color = color_code;
  }
});
if(flag == 'footer'){
  return 'background-color:'+color_code;
}
if(flag == 'button'){
  return color_code;
}

},
forgotPass(){
    this.buttonFlag =true;
    this.isDark = false;
    axios({
          method: "POST",

          url: "/api/auth/forgot-password",
          data: {
            email: this.email,
          }
        })
          .then(response => {
                this.sendFlag = 1;
                Vue.$toast.success('Forgot Password Mail sent', {
                position: 'top-right'
                });
                this.buttonFlag =false;
                this.isDark = true;
                this.pageFlag = 'login';
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          })
},
gotosignup: function () {
    let self = this;
    self.$router.push('/signup');
},gotoGoogle(){
      let self = this;
        this.$router.push('/redirect/google');
        location.reload();
  },
  gotoMs(){
      let self = this;
        this.$router.push('/redirect/microsoft');
        location.reload();
  },
  gotoYahoo(){
      let self = this;
        this.$router.push('/redirect/yahoo');
        location.reload();
  },
  callNumber(phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    },
    sendEmail(email) {
      window.location.href = `mailto:${email}`;
    },
    gotoLinks(link){
      if(!link)
      link = '#'
      const newTab = window.open('', '_blank');
      newTab.location.href = link;
    },
    getCompanyInfo(id){

  axios({
          method: "POST",

          url: "/api/get-card",
          data: {
            id: id
          }

        })
          .then(async(response) => {
            if(response.data.flag == 1){
              if(id == 'reps'){

                this.reps_users = response.data.user;
                this.reps_flag = true;

              }else{
                this.company = response.data.user;
                this.vcard = response.data.vcard[0];
                this.sales_agent_count = response.data.sales_agents
                this.ref_agent_count = response.data.ref_agents
                // this.background =   this.base_url_img+'vcard/'+this.company.background
                // this.company.items = JSON.parse(JSON.parse(this.company.items))
                if(this.company.video_background){
                  let video_back = this.company.video_background.split("/");
                  this.vimeo_id = video_back[0]
                  this.vimeo_account = video_back[1]
                }
                let url = process.env.VUE_APP_WASBI_URL.replace('/logo','');
                const{base64Image, mimeType} = await this.convertImageToBase64(this.base_url_img+this.company.avatar);
                this.base64Image = base64Image
                this.avatar_mimeType = mimeType
              }
            }else{
              this.$router.push('/login');
            }
          })

},
renderChart() {
  let self = this;
      const ctx = document.getElementById('chart-interest').getContext('2d');
       const innerLabel = {
        id: 'innerLabel',
        afterDatasetDraw(chart, args, pluginOptions) {
          const { ctx } = chart;
          const meta = args.meta;
          const xCoor = meta.data[0].x;
          const yCoor = meta.data[0].y;
          const perc = chart.data.datasets[0].data[0] / meta.total * 100;
          ctx.save();
          ctx.textAlign = 'center';
          ctx.font = '22px sans-serif';
          ctx.fillText('$'+self.monthly_payment+'/month', xCoor, yCoor);
          ctx.restore();
        },
      };
      this.chartInstance = new Chart(ctx, {
        type: 'doughnut',
        plugins: [innerLabel],
        data: {
          labels: ['Principal','Interest Paid'],
          datasets: [
            {
              data: [self.total_loan_amount.toFixed(0),self.total_interest],
              backgroundColor: ['#005CB2','#36A2EB'],
              hoverBackgroundColor: [ '#005CB2','#36A2EB'],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
        labels: {
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets[0].data.map((data, i) => ({
              text: `${chart.data.labels[i]} $${data}`,
              fillStyle: datasets[0].backgroundColor[i],
              index: i
            }))
          }
        }
      }
          },
          centerText: 'aaaa',
        },
      });
      // var text = "82%",
      //       textX = Math.round((width - this.chart.ctx.measureText(text).width) / 2),
      //       textY = height / 2;

      //   this.chartInstance.ctx.fillText(text, textX, textY);
    },
getCardDetail() {

        const domain = window.location.host
        let flag = 1;
        let header = { headers : {
                    Authorization:"Bearer " + localStorage.getItem('token')
                    }
            }
            //this.queryAndIndeterminate();
            const id = this.$route.params.id;
          axios
            .post("/api/get-vehicle/"+id,{domain: domain},header)
            .then(response => {
                let data = response.data;

               if (flag == 1) {
                  this.vehicle = data.data;
                  this.booked_dates = data.bookedDates;
                  this.calculator.total_amount = this.vehicle.amount;
                  this.calculator.down_payment = this.vehicle.amount ? (this.vehicle.amount * 0.1).toFixed(2) : 0;
                  this.calculator.credit_range = '781 - 850';
                  this.setCreditRange()
                  this.getUserLocation();
                  this.loader = false
                  this.getDiscountForVehicle();
                  this.loadSavedCoupons();
                  // this.renderChart();
                  //this.loaderOff();
                  //this.getGHLChat()
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

             })
              .catch(err => {
                Vue.$toast.error(err, {
                position: 'top-right'
                });

               });

         },

      getDiscountForVehicle() {
        this.loadingDiscount = true;
        axios.post(`/api/calculate-discount`, {
          vehicle_id: this.vehicle.id,
          days: this.totalDays // assuming this.calculator.days is the correct number of days
        })
        .then(response => {
          const discounts = response.data;
          this.discount_rules = discounts.discount;

          // We don't need to calculate the discount amount here anymore
          // The finalAmount computed property will handle this
          // This allows both the coupon discount and discount_rules to be applied together
        })
        .catch(error => {
          console.error('Error fetching discounts:', error);
          this.discount_rules = null;
        })
        .finally(() => {
          this.loadingDiscount = false;
        });
      },
    addContact() {
      const contact = {
        name: "John Doe",
        phone: "123-456-7890",
        email: "johndoe@example.com",
        address: "1234 Example St, Anytown, USA",
      };

      if ('contacts' in navigator && 'ContactsManager' in window) {
        navigator.contacts.select(
          ['name', 'email', 'tel', 'address'],
          { multiple: false }
        ).then((contacts) => {
          const newContact = new Contact({
            name: [contact.name],
            tel: [{ value: contact.phone }],
            email: [{ value: contact.email }],
            address: [{ value: contact.address }],
          });
          newContact.save();
        }).catch((error) => {
          console.error('Error adding contact:', error);
        });
      } else {
        alert(`Name: ${contact.name}\nPhone: ${contact.phone}\nEmail: ${contact.email}\nAddress: ${contact.address}`);
      }
    },
    currencyFormat(value){
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(value);
          },
          openGallery(item){
            this.dialogPreviewFile = true
            this.selectedFile = item
          },
      getPreApproved() {
      this.$router.push('/agreement');
    },
    setCreditRange(){
      if(this.calculator.credit_range == '< 500')
        this.calculator.interest_rate = this.company_settings.Interest_rate_1
      if(this.calculator.credit_range == '501 - 600')
        this.calculator.interest_rate = this.company_settings.Interest_rate_2
      if(this.calculator.credit_range == '601 - 660')
        this.calculator.interest_rate = this.company_settings.Interest_rate_3
      if(this.calculator.credit_range == '661 - 780')
        this.calculator.interest_rate = this.company_settings.Interest_rate_4
      if(this.calculator.credit_range == '781 - 850')
        this.calculator.interest_rate = this.company_settings.Interest_rate_5

    },
    disableBookedDates(date) {
      return !this.booked_dates.includes(date); // Disable if date exists in bookedDates array
    },
    getSettings() {
    let flag = 1;
    let url = process.env.VUE_APP_WASBI_URL
    var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
      axios({
          method: "POST",
          url: "/api/get-company-settings",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            let data = response.data.data;
            if(data){
              this.company_settings = data.settings
               localStorage.setItem('settings', JSON.stringify(data.settings));
               if(data.settings.backgroung_logo)
                localStorage.setItem('admin_bg', JSON.stringify(url+data.settings.backgroung_logo));
              else
                localStorage.setItem('admin_bg','');
              this.getCardDetail();
            }


         })
          .catch(err => {
            // Vue.$toast.error(err, {
            // position: 'top-right'
            // });

           });

     },
     checkPermission(flag) {

      if(flag == 'sales'){
        let status = 0;
        if(this.company_settings.sales_rep_flag == 'None'){
          return false
        }
        else if(this.company_settings.sales_rep_flag == 'All'){
          return true
        }else{
          if(this.company_settings.sales_rep_accounts.length != 0){
          this.company_settings.sales_rep_accounts.forEach(val => {
            if(val == this.company.user_id){
              status = 1;
            }

          });
        }
          return status
        }
      }
      if(flag == 'ref'){
        let status_ref = 0;
        if(this.company_settings.ref_rep_flag == 'None'){
          return false
        }
        else if(this.company_settings.ref_rep_flag == 'All'){
          return true
        }else{
          this.company_settings.ref_rep_accounts.forEach(val => {
            if(val == this.company.user_id){
              status_ref = 1;
            }

          });
          return status_ref
        }
      }
     },
  exportToFile(card, name='contact', force=true) {
            const a = document.createElement('a');
            const file = new Blob([card], { type: 'text/vcard'});

            a.href = URL.createObjectURL(file);
            a.download = name;
            a.click();

            URL.revokeObjectURL(a.href);
  },
  getIcon(id,value){
    if(id == 'Phone'){
      this.phone = value
      return 'fa fa-phone';
    }
    if(id == 'Zoom'){
      this.zoom_value = value
      return 'fas fa-video';
    }
    if(id == 'Event'){
      this.event_value = value
      return 'fas fa-calendar-check';
    }
    if(id == 'Email')
      return 'fas fa-envelope';
    if(id == 'Whatsapp')
      return 'fab fa-whatsapp';
    if(id == 'SMS/Text')
      return 'fas fa-comments';
    if(id == 'Website')
      return 'fas fa-link';
    if(id == 'Instagram')
      return 'fab fa-instagram';
    if(id == 'Snapchat')
      return 'fab fa-snapchat';
    if(id == 'Twitter')
      return 'fab fa-twitter';
    if(id == 'Facebook')
      return 'fab fa-facebook';
    if(id == 'LinkedIN')
      return 'fab fa-linkedin';
    else
      return 'fas fa-link';
  },
      // Function to convert image URL to Base64
  async convertImageToBase64(imageUrl) {
    let self = this;
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const mimeType = blob.type; // Get the MIME type of the image
    // this.avatar_mimeType = mimeType;
    // this.base64Image = blob
    // const reader = new FileReader();
    //     reader.onloadend = () => { self.base64Image = reader.result.split(',')[1]; self.avatar_mimeType = mimeType }; // Get Base64 string without the prefix
    //     reader.onerror = reject;
    //     reader.readAsDataURL(blob);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve({ base64Image: reader.result.split(',')[1], mimeType }); // Get Base64 string without the prefix
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
},
calculateTotalLoan(){
  this.total_loan_amount = this.calculator.total_amount - this.calculator.down_payment - this.calculator.trade_in;
  const monthlyInterestRate = this.calculator.interest_rate / 100 / 12;

  // The number of payments is now directly passed as `tenureMonths`
  let tenureMonths = 0;
  if(this.calculator.tenure == 0)
    tenureMonths = 24;
  if(this.calculator.tenure == 1)
    tenureMonths = 36;
  if(this.calculator.tenure == 2)
    tenureMonths = 48;
  if(this.calculator.tenure == 3)
    tenureMonths = 60;
  if(this.calculator.tenure == 4)
    tenureMonths = 72;
  if(this.calculator.tenure == 5)
    tenureMonths = 84;
  const totalPayments = tenureMonths;

  // Calculate the monthly payment using the formula
  const monthlyPayment = this.total_loan_amount * (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, totalPayments)) /
      (Math.pow(1 + monthlyInterestRate, totalPayments) - 1);

  // Calculate total amount paid over the loan term
  const totalPaid = monthlyPayment.toFixed(0) * totalPayments;

  // Calculate total interest paid
  const totalInterest = totalPaid - this.total_loan_amount;
  this.total_interest = totalInterest.toFixed(0);
  this.monthly_payment = monthlyPayment.toFixed(0);
  if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  this.renderChart()


},
/**
 * checkForm
 * login the user with valid email/pass
 */
async addCard(value) {
            const myVCard = new VCard()
            myVCard.addName(this.company.first_name+' '+this.company.last_name)
            if(this.company.business_name)
              myVCard.addCompany(this.company.business_name)
            myVCard.addEmail(this.company.email)
            myVCard.addPhoneNumber(this.company.phone_m)

            // Add social media links if available
            if (this.company.facebook) {
                myVCard.addSocial(this.company.facebook, 'Facebook');
            }
            if (this.company.instagram) {
                myVCard.addSocial(this.company.instagram, 'Instagram');
            }
            if (this.company.linkedin) {
                myVCard.addSocial(this.company.linkedin, 'TikTok');
            }
            if (this.company.website) {
                myVCard.addSocial(this.company.website, 'Website');
            }
            if (this.company.youtube) {
                myVCard.addSocial(this.company.youtube, 'YouTube');
            }
            if (this.company.avatar) {
              if (this.avatar_mimeType == 'image/png') {
                myVCard.addPhoto(`${this.base64Image}`, 'PNG');
              }
              else if (this.avatar_mimeType == 'image/jpeg') {
                myVCard.addPhoto(`${this.base64Image}`, 'JPEG');
              }
              else if (this.avatar_mimeType == 'image/gif') {
                myVCard.addPhoto(`${this.base64Image}`, 'GIF');
              }
            }
            const output = myVCard.toString()
            const preElement = document.querySelector('#output')
            const outputNode = document.createTextNode(output)
            this.exportToFile(output,'contact',true)

    },

    // Open the spinning wheel dialog
    openSpinWheel() {
      this.currentPrize = null;
      this.loadingWheel = true;
      this.spinWheelDialog = true;

      // Load saved coupons
      this.loadSavedCoupons();

      // Get wheel settings and segments from the API
      axios({
        method: "GET",
        url: "/api/spinning-wheel/config",
        headers: {
          Authorization: "Bearer " + localStorage.getItem('rental_token')
        }
      })
      .then(response => {
        if (response.data.flag === 1) {
          // Set wheel settings
          if (response.data.settings) {
            this.wheelSettings = {
              ...this.wheelSettings,
              ...response.data.settings
            };
          }

          // Set wheel segments
          if (response.data.segments && response.data.segments.length > 0) {
            // Store the full segment data for later use
            this.segmentData = response.data.segments;

            // Extract just the labels for the wheel display
            this.wheelSegments = response.data.segments;
            this.wheelColors = response.data.segments.map(segment => segment.color || '#FF9800');
          } else {
            // Default segments if none are configured
            this.wheelSegments = [];
            this.wheelColors = [];
            this.segmentData = [];
          }

          // Get remaining spins
          this.remainingSpins = response.data.remaining_spins || 0;
        } else {
          Vue.$toast.error(response.data.message || 'Failed to load spinning wheel settings', {
            position: 'top-right'
          });
        }
      })
      .catch(error => {
        console.error('Error loading wheel settings:', error);
        Vue.$toast.error('Error loading spinning wheel settings', {
          position: 'top-right'
        });

        // Set default segments
        this.wheelSegments = ['5% OFF', '10% OFF', '15% OFF', 'Try Again', '20% OFF', 'Free Gift', 'Try Again', '$10 OFF'];
        this.wheelColors = ['#FF9800', '#4CAF50', '#2196F3', '#f44336', '#9C27B0', '#FFEB3B', '#f44336', '#3F51B5'];
        this.remainingSpins = 1; // Default to 1 spin for testing
      })
      .finally(() => {
        this.loadingWheel = false;
      });
    },

    // Close the spinning wheel dialog
    closeSpinWheel() {
      if (this.currentPrize && this.currentPrize.type === 'discount') {
        // If there's a discount, apply it to the vehicle price
        this.appliedDiscount = this.currentPrize;

        // Save the coupon for future use if not already used
        // this.saveCoupon(this.currentPrize);
      }

      this.spinWheelDialog = false;
    },

    // Load saved coupons from localStorage
    loadSavedCoupons() {
      const savedCoupons = localStorage.getItem('savedCoupons');
      if (savedCoupons) {
        try {
          this.savedCoupons = JSON.parse(savedCoupons);

          // Check if there's a coupon for this vehicle
          const vehicleCoupon = this.savedCoupons.find(coupon =>
            coupon.vehicleId === this.vehicle.id && !coupon.used
          );

          if (vehicleCoupon) {
            // Apply the saved coupon
            this.appliedDiscount = vehicleCoupon;
          }
        } catch (error) {
          console.error('Error parsing saved coupons:', error);
          this.savedCoupons = [];
        }
      } else {
        this.savedCoupons = [];
      }
    },

    // Save a coupon to localStorage
    saveCoupon(coupon) {
      // Add vehicle ID and used status to the coupon
      const couponToSave = {
        ...coupon,
        vehicleId: this.vehicle.id,
        used: false,
        dateCreated: new Date().toISOString()
      };

      // Check if this coupon already exists
      const existingCouponIndex = this.savedCoupons.findIndex(c =>
        c.code === couponToSave.code && c.vehicleId === couponToSave.vehicleId
      );

      if (existingCouponIndex >= 0) {
        // Update existing coupon
        this.savedCoupons[existingCouponIndex] = couponToSave;
      } else {
        // Add new coupon
        this.savedCoupons.push(couponToSave);
      }

      // Save to localStorage
      localStorage.setItem('savedCoupons', JSON.stringify(this.savedCoupons));
    },

    // Mark a coupon as used
    markCouponAsUsed(couponCode) {
      const couponIndex = this.savedCoupons.findIndex(c => c.code === couponCode);
      if (couponIndex >= 0) {
        this.savedCoupons[couponIndex].used = true;
        localStorage.setItem('savedCoupons', JSON.stringify(this.savedCoupons));
      }
    },

    // Handle the completion of the wheel spin
    handleSpinComplete(segmentIndexOrObject) {
      // Check if we received a segment object directly or an index
      let segment = null;
      let segmentIndex = null;

      if (typeof segmentIndexOrObject === 'object') {
        // We received the segment object directly
        segment = segmentIndexOrObject;
        // Find the index of this segment in our array (for fallback if needed)
        segmentIndex = this.segmentData.findIndex(s =>
          s.label === segment.label && s.type === segment.type && s.value === segment.value
        );
      } else {
        // We received an index
        segmentIndex = segmentIndexOrObject;
      }

      // Get the segment data based on the segment index or use the direct segment object
      if (segment || (this.segmentData && this.segmentData.length > 0 && segmentIndex < this.segmentData.length)) {
        // Use the direct segment object or get it from the array
        segment = segment || this.segmentData[segmentIndex];

        // Check if this is a "Try Again" segment
        const isTryAgainSegment =
          segment.type === 'try_again' ||
          (segment.label && segment.label.includes('Try Again')) ||
          (typeof segment.description === 'string' && segment.description.includes('Try Again'));

        // Set the current prize based on the segment data
        if (isTryAgainSegment) {
          // This is a "Try Again" segment
          this.currentPrize = {
            type: 'try_again',
            label: segment.label || 'Try Again',
            description: segment.description || 'Better luck next time!'
          };
        } else if (segment.type === 'discount') {
          this.currentPrize = {
            type: 'discount',
            discountType: segment.value && segment.value.toString().includes('%') ? 'percentage' : 'fixed',
            value: segment.value,
            code: segment.code || `SPIN${segment.value}`
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else if (segment.type === 'gift_card') {
          this.currentPrize = {
            type: 'gift_card',
            value: segment.value,
            code: segment.code || 'GIFTCARD'
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else if (segment.type === 'points') {
          this.currentPrize = {
            type: 'points',
            value: segment.value
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else if (segment.type === 'custom') {
          this.currentPrize = {
            type: 'custom',
            description: segment.description || 'Custom prize!'
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else {
          // Other non-prize segment
          this.currentPrize = {
            type: 'custom',
            description: segment.description || 'Special Prize!'
          };
        }
      } else {
        // Fallback for when segment data is not available
        // Get the prize based on the segment text
        const segmentText = segmentIndex !== null && segmentIndex >= 0 && segmentIndex < this.wheelSegments.length ?
          this.wheelSegments[segmentIndex] : 'Try Again'

        // Parse the segment text to determine the prize
        if (segmentText.includes('OFF')) {
          let value = 0;
          let discountType = 'percentage';

          if (segmentText.includes('%')) {
            // Percentage discount
            value = parseInt(segmentText.match(/\d+/)[0], 10);
          } else if (segmentText.includes('$')) {
            // Fixed amount discount
            value = parseInt(segmentText.match(/\d+/)[0], 10);
            discountType = 'fixed';
          }

          this.currentPrize = {
            type: 'discount',
            discountType: discountType,
            value: value,
            code: `SPIN${value}${discountType === 'percentage' ? 'PCT' : ''}`
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else if (segmentText.includes('Gift')) {
          this.currentPrize = {
            type: 'gift_card',
            value: 10,
            code: 'GIFTCARD10'
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else if (segmentText.includes('Points')) {
          const value = parseInt(segmentText.match(/\d+/)[0], 10);
          this.currentPrize = {
            type: 'points',
            value: value
          };

          // Save the prize to the user's account
          this.savePrize(this.currentPrize);
        } else if (segmentText.includes('Try Again')) {
          // Try again segment
          this.currentPrize = {
            type: 'try_again',
            label: 'Try Again',
            description: 'Better luck next time!'
          };
        } else {
          // Unknown segment
          Vue.$toast.info('Unknown prize type', {
            position: 'top-right'
          });
        }
      }

      // Decrement remaining spins
      if (this.remainingSpins > 0) {
        this.remainingSpins--;
      }

      // After a short delay, reload the coupons to get the latest from the API
      setTimeout(() => {
        this.loadSavedCoupons();
      }, 2000); // 2 second delay to allow the API to process the prize

      this.spinInProgress = false;
    },

    // Load saved coupons from API and check if any apply to the current vehicle
    loadSavedCoupons() {
      // Only proceed if user is logged in and we have a vehicle
      if (!this.isLoggedIn || !this.vehicle) {
        return;
      }

      // Show loading indicator
      this.loadingDiscount = true;

      // Get user's prizes from the API
      axios({
        method: "GET",
        url: `/api/spinning-wheel/user-prizes${this.vehicle ? '?vehicle_id=' + this.vehicle.id : ''}`,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('rental_token')
        }
      })
      .then(response => {
        if (response.data.flag === 1 && response.data.prizes && response.data.prizes.length > 0) {
          // Process the prizes from the API
          const prizes = response.data.prizes;

          // Filter for discount prizes only
          const discountPrizes = prizes.filter(prize => prize.prize_type === 'discount' && !prize.redeemed);

          if (discountPrizes.length > 0) {
            // Convert API format to our internal format
            this.savedCoupons = discountPrizes.map(prize => ({
              type: prize.prize_type,
              discountType: prize.prize_value && prize.prize_value.toString().includes('%') ? 'percentage' : 'fixed',
              value: parseInt(prize.prize_value.toString().replace(/[^0-9]/g, ''), 10),
              code: prize.prize_code || `SPIN${prize.id}`,
              vehicleId: prize.vehicle_id || null,
              id: prize.id,
              timestamp: new Date(prize.created_at).getTime()
            }));

            // Find coupons for this vehicle
            const vehicleCoupons = this.savedCoupons.filter(coupon =>
              !coupon.vehicleId || coupon.vehicleId === this.vehicle.id
            );

            if (vehicleCoupons.length > 0) {
              // Sort by value (highest first)
              vehicleCoupons.sort((a, b) => {
                // For percentage discounts, compare percentages
                if (a.discountType === 'percentage' && b.discountType === 'percentage') {
                  return b.value - a.value;
                }
                // For fixed discounts, compare amounts
                if (a.discountType === 'fixed' && b.discountType === 'fixed') {
                  return b.value - a.value;
                }
                // Prioritize fixed discounts for high-value vehicles
                if (this.vehicle.rent_price_per_day > 100) {
                  return a.discountType === 'fixed' ? -1 : 1;
                } else {
                  return a.discountType === 'percentage' ? -1 : 1;
                }
              });

              // Apply the best coupon
              this.appliedDiscount = vehicleCoupons[0];

              // Show notification
              Vue.$toast.success(`Discount coupon applied: ${this.appliedDiscount.discountType === 'percentage' ?
                this.appliedDiscount.value + '%' : '$' + this.appliedDiscount.value} OFF`, {
                position: 'top-right'
              });
            }
          } else {
            this.savedCoupons = [];
          }
        } else {
          this.savedCoupons = [];
        }
      })
      .catch(error => {
        console.error('Error loading saved coupons:', error);
        this.savedCoupons = [];
      })
      .finally(() => {
        this.loadingDiscount = false;
      });
    },

    // Save the prize to the user's account
    savePrize(prize) {
      if (!this.isLoggedIn) {
        Vue.$toast.error('You need to be logged in to claim prizes', {
          position: 'top-right'
        });
        return;
      }

      // Format the prize data to match the API expectations
      const prizeData = {
        type: prize.type,
        label: prize.type === 'discount' ?
          (prize.discountType === 'percentage' ? `${prize.value}% OFF` : `$${prize.value} OFF`) :
          (prize.type === 'gift_card' ? `$${prize.value} Gift Card` :
           prize.type === 'points' ? `${prize.value} Points` : 'Custom Prize'),
        value: prize.value,
        code: prize.code
      };

      // If it's a discount, apply it immediately
      if (prize.type === 'discount') {
        // Create a coupon object
        const coupon = {
          type: prize.type,
          discountType: prize.discountType,
          value: prize.value,
          code: prize.code,
          vehicleId: this.vehicle ? this.vehicle.id : null,
          timestamp: new Date().getTime()
        };

        // Apply the discount immediately
        this.appliedDiscount = coupon;
      }

      axios({
        method: "POST",
        url: "/api/spinning-wheel/save-prize",
        data: {
          prize: prizeData,
          vehicle_id: this.vehicle ? this.vehicle.id : null
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem('rental_token')
        }
      })
      .then(response => {
        if (response.data.flag === 1) {
          Vue.$toast.success(`Prize saved successfully!`, {
            position: 'top-right'
          });
        } else {
          Vue.$toast.error(response.data.message || 'Failed to save prize', {
            position: 'top-right'
          });
        }
      })
      .catch(error => {
        console.error('Error saving prize:', error);
        Vue.$toast.error('Error saving prize', {
          position: 'top-right'
        });
      });
    },

    // Spin the wheel to get a prize
    spinTheWheel() {
      if (!this.isLoggedIn) {
        Vue.$toast.error('You need to be logged in to spin the wheel', {
          position: 'top-right'
        });
        return;
      }

      if (this.remainingSpins <= 0) {
        Vue.$toast.error(`You have no spins remaining for this ${this.wheelSettings.spinLimitPeriod}`, {
          position: 'top-right'
        });
        return;
      }

      this.spinInProgress = true;

      // We don't need to call the API to record the spin separately
      // The prize recording will handle this
      // The actual prize will be determined when the wheel stops spinning
    },

    // Go to login page
    goToLogin() {
      this.loginDialog = true;
    },

    // Remove the applied discount
    removeDiscount() {
      this.appliedDiscount = null;
      Vue.$toast.info('Discount removed', {
        position: 'top-right'
      });
    },

    // Open the spinning wheel dialog
    openSpinWheel() {
      // Close the booking dialog temporarily
      this.bookingDialog = false;

      // Open the spinning wheel dialog
      this.spinWheelDialog = true;

      // Load the wheel configuration if not already loaded
      if (this.wheelSegments.length === 0) {
        this.loadWheelConfig();
      }
    },

    // Load the wheel configuration from the API
    loadWheelConfig() {
      this.loadingWheel = true;

      // Get wheel settings and segments from the API
      axios({
        method: "GET",
        url: "/api/spinning-wheel/config",
        headers: {
          Authorization: "Bearer " + localStorage.getItem('rental_token')
        }
      })
      .then(response => {
        if (response.data.flag === 1) {
          // Set wheel settings
          if (response.data.settings) {
            this.wheelSettings = {
              ...this.wheelSettings,
              ...response.data.settings
            };
          }

          // Set wheel segments
          if (response.data.segments && response.data.segments.length > 0) {
            // Store the full segment data for later use
            this.segmentData = response.data.segments;

            // Extract just the labels for the wheel display
            this.wheelSegments = response.data.segments;
            this.wheelColors = response.data.segments.map(segment => segment.color || '#FF9800');
          } else {
            // Default segments if none are configured
            this.wheelSegments = ['5% OFF', '10% OFF', '15% OFF', 'Try Again', '20% OFF', 'Free Gift', 'Try Again', '$10 OFF'];
            this.wheelColors = ['#FF9800', '#4CAF50', '#2196F3', '#f44336', '#9C27B0', '#FFEB3B', '#f44336', '#3F51B5'];
          }

          // Get remaining spins
          this.getRemainingSpins();
        } else {
          Vue.$toast.error(response.data.message || 'Failed to load spinning wheel settings', {
            position: 'top-right'
          });

          // Set default segments
          this.wheelSegments = ['5% OFF', '10% OFF', '15% OFF', 'Try Again', '20% OFF', 'Free Gift', 'Try Again', '$10 OFF'];
          this.wheelColors = ['#FF9800', '#4CAF50', '#2196F3', '#f44336', '#9C27B0', '#FFEB3B', '#f44336', '#3F51B5'];
        }
      })
      .catch(error => {
        console.error('Error loading wheel settings:', error);
        Vue.$toast.error('Error loading spinning wheel settings', {
          position: 'top-right'
        });

        // Set default segments
        this.wheelSegments = ['5% OFF', '10% OFF', '15% OFF', 'Try Again', '20% OFF', 'Free Gift', 'Try Again', '$10 OFF'];
        this.wheelColors = ['#FF9800', '#4CAF50', '#2196F3', '#f44336', '#9C27B0', '#FFEB3B', '#f44336', '#3F51B5'];
      })
      .finally(() => {
        this.loadingWheel = false;
      });
    },

    // Get the remaining spins for the current user
    getRemainingSpins() {
      if (!this.isLoggedIn) {
        this.remainingSpins = 0;
        return;
      }

      axios({
        method: "GET",
        url: "/api/spinning-wheel/user-spins",
        headers: {
          Authorization: "Bearer " + localStorage.getItem('rental_token')
        }
      })
      .then(response => {
        if (response.data.flag === 1) {
          this.remainingSpins = response.data.remaining_spins || 0;
        } else {
          this.remainingSpins = 0;
        }
      })
      .catch(error => {
        console.error('Error getting remaining spins:', error);
        this.remainingSpins = 0;
      });
    },

    // Close the spinning wheel and reopen the booking dialog
    closeSpinWheel() {
      this.spinWheelDialog = false;
      this.currentPrize = null;

      // Reopen the booking dialog
      // setTimeout(() => {
      //   this.bookingDialog = true;
      // }, 300);
    }
  },

  computed: {
    isTryAgainPrize() {
      if (!this.currentPrize) return false;

      // Check if it's a try again prize by type or label
      return this.currentPrize.type === 'try_again' ||
             (this.currentPrize.label && this.currentPrize.label.includes('Try Again')) ||
             (typeof this.currentPrize.description === 'string' && this.currentPrize.description.includes('Try Again'));
    },

    isLoggedIn() {
      return localStorage.getItem('rental_token') !== null;
    },
    filteredUsers() {
      const query = this.search_rep.toLowerCase();
      return this.reps_users.filter(user => {
        const fullName = `${user.year} ${user.make} ${user.model}`.toLowerCase();
        return fullName.includes(query);
      });
    },
    totalAmount() {
      if (!this.tripStartDate || !this.tripEndDate) return 0; // Prevents errors if dates are empty

      const startDate = new Date(this.tripStartDate);
      const endDate = new Date(this.tripEndDate);

      // Ensure endDate is after startDate
      if (endDate < startDate) return 0;

      // Calculate total days (including both start and end dates)
      const totalDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

      // Return the total price
      return totalDays * this.vehicle.rent_price_per_day;
    },

    discountedPrice() {
      if (!this.appliedDiscount || !this.vehicle) return this.vehicle?.rent_price_per_day || 0;

      let price = parseFloat(this.vehicle.rent_price_per_day);

      if (this.appliedDiscount.discountType === 'percentage') {
        const discountAmount = (price * this.appliedDiscount.value) / 100;
        price = price - discountAmount;
      } else {
        price = price - this.appliedDiscount.value;
      }

      // Make sure the price is not negative
      return Math.max(0, price).toFixed(2);
    },
    finalAmount() {
      // Calculate the final amount after discount
      const baseAmount = JSON.parse(JSON.stringify(this.totalAmount));
      let totalDiscount = 0;

      // Calculate discount from applied coupon
      if (this.appliedDiscount) {
        if (this.appliedDiscount.discountType === 'percentage') {
          totalDiscount += parseFloat((baseAmount * this.appliedDiscount.value / 100).toFixed(2));
        } else {
          totalDiscount += parseFloat(this.appliedDiscount.value);
        }
      }


      // Also apply discount rules if available
      if (this.discount_rules) {
        if (this.discount_rules.type === 'percentage') {
          // Apply percentage to the amount after coupon discount
          // const remainingAmount = baseAmount - totalDiscount;alert(parseFloat((baseAmount * this.discount_rules.value / 100).toFixed(2)))
          totalDiscount += parseFloat((baseAmount * this.discount_rules.value / 100).toFixed(2));
        } else {
          totalDiscount += parseFloat(this.discount_rules.value);
        }
      }
      console.log(baseAmount);
      // Set the calculated discount amount for display
      this.calculatedDiscountAmount = totalDiscount.toFixed(2);

      // Ensure the final amount is not negative
      return Math.max(0, (baseAmount - totalDiscount)).toFixed(2);
    },
    totalDays() {
      if (!this.tripStartDate || !this.tripEndDate) return 0; // Prevents errors if dates are empty

      const startDate = new Date(this.tripStartDate);
      const endDate = new Date(this.tripEndDate);

      // Ensure endDate is after startDate
      if (endDate < startDate) return 0;

      // Calculate total days (including both start and end dates)
      const totalDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

      return totalDays;
    }

  },
  watch: {
    pageTitle() {
      this.$meta().refresh();
    },
    tripStartDate(val) {
      this.formatDate(val);
      this.getDiscountForVehicle();
    },
    tripEndDate(val) {
      this.formatDate2(val);
      this.getDiscountForVehicle();
    }
  },

};
</script>
<style>
  /* Spinning wheel styles */
  .spin-wheel-icon-glow {
    animation: pulse 1.5s infinite;
    box-shadow: 0 0 0 rgba(255, 152, 0, 0.4);
  }

  /* Applied coupon styles */
  .applied-coupon {
    background-color: #f1f8e9;
    border: 1px solid #c5e1a5;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .applied-coupon:hover {
    background-color: #e8f5e9;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  /* Discount breakdown styles */
  .discount-breakdown {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 12px;
    font-size: 14px;
  }

  .discount-breakdown .green--text {
    font-weight: 500;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(255, 152, 0, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 152, 0, 0);
    }
  }

  .prize-result {
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }
  .check-login .v-label {
    color: white;
  }
  .check-login .v-icon {
    color: white;
  }
.input-login .v-icon{
    color: #FDE038!important;
}
.input-login .v-label{
  color: #FDE038!important;
}
.input-login #input-6{
  color: #FDE038!important;
}
.input-login #input-10{
  color: #FDE038!important;
}
.header-card{
  overflow: hidden;
  position: relative;
  z-index: 3;
  border-bottom: 1px solid rgb(217, 218, 220);
  color: rgb(20, 20, 20);
  background: linear-gradient(45deg, rgb(255, 117, 140), rgb(255, 126, 179));
}
.cards{
  box-sizing: border-box;
  position: relative;
  display: block;
  padding: 80px 10px 30px;
  background-color: rgb(230, 230, 230);
  border-bottom: 1px solid rgb(217, 218, 220);
  text-align: center;
  cursor: pointer;
  user-select: none;
  color: rgb(20, 20, 20);
}
.cards:nth-child(2n+1) {
  border-right: 1px solid rgb(217, 218, 220);
}
.cards:hover {
  color: skyblue!important;
  background: #D9E6F4;
}
.header {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  border: solid #fff;
  border-width: 0 1px;
  z-index: 1;
  background: white;
  font-weight: 700;
}
.footer {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  border: 0px;
  border-width: 0 1px;
  z-index: 1;
  background: white;
  font-weight: 700;
  width: 100%;
}
.elementor-container {
text-align: center;
}
.elementor-column {
  position: relative;
  min-height: 1px;
  display: flex;
  justify-content: center;
}
.elementor-column-header {
  position: relative;
  min-height: 1px;
  display: flex;
  justify-content: center;
  margin-bottom: -170px;
  margin-top: 50px;
}
.elementor-heading-title-card{
  color: #FFFFFF;
  font-family: "Montserrat", Sans-serif;
  font-weight: 800;
  text-shadow: 4px 4px 10px rgba(0,0,0,0.3);
}
.elementor-icon-wrapper{
  font-size: 25px;
  color: #000000;
}
.elementor-element.elementor-element-09cffa4 img {
  width: 200px;
  height: 200px;
  border-style: solid;
  border-width: 5px 5px 5px 5px;
  border-color: #FFFFFF;
  border-radius: 300px 300px 300px 300px;

}
.elementor-element.elementor-element-a14cd74:not(.elementor-motion-effects-element-type-background), .elementor-581 .elementor-element.elementor-element-a14cd74 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background: url("https://s3.us-central-1.wasabisys.com/quantumresolution/logo/david-bg.jpg") 50% 50%;
    background-size: auto;
  background-size: cover;
  padding: 60px 0px 70px 0px;
  position: relative;
}
.elementor-shape-bottom {
  bottom: -1px;
}
.elementor-shape {
  overflow: hidden;
  position: absolute;
  left: 0;
  width: 100%;
  line-height: 0;
  direction: ltr;
}
.elementor-shape .elementor-shape-fill {
  fill: #fff;
  transform-origin: center;
  transform: rotateY(0deg);
}
.elementor-heading-title2 {
  color: #303030;
  font-family: "Lora", Sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
}
 .elementor-social-icon {
  background-color: #021033;
}
.elementor-icon.elementor-social-icon {
  border-radius: 50%;
  font-size: 15px;
  line-height: 25px;
  width: 25px;
  display: inline-block;

  height: 25px;
}
.elementor-screen-only, .screen-reader-text, .screen-reader-text span, .ui-helper-hidden-accessible {
  position: absolute;
  top: -10000em;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}
.elementor-widget-container {
  text-align: center;
}
.elementor-social-icon i {
  color: #FFFFFF;
}
.elementor-grid-item{
  margin: 5px;
}
.slider {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.slide.active {
  visibility: visible;
  opacity: 1;
}

iframe {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.container1 {
  display: flex;
  align-items: center;
  gap: 8px;
}
 .elementor-button {
  display: block;
  font-family: "Poppins", Sans-serif;
  font-size: 17px;
  font-weight: 400;
  text-transform: capitalize;
  fill: var( --e-global-color-6aef213 );
  color: var( --e-global-color-6aef213 );
  background-color: #FEFEFE;
  border-style: solid;
  border-width: 3px 3px 3px 3px;
  border-color: var( --e-global-color-6aef213 );
  border-radius: 50px 50px 50px 50px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.32);
  padding: 14px 50px 14px 50px;
}

.elementor-background-video-container {

    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    overflow: hidden;
    z-index: 0;
    direction: ltr;
    transition: opacity 1s;
    pointer-events: none;

}
 .elementor-background-video-hosted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.sub-slider .slick-list .slick-slide{
  padding-right: 5px;
}
.w-101{
  width: 98% !important;
}
.vehicle-details-module__content {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.25);
}
.v-btn-toggle .v-btn--active {
  color: #fff !important;
  background-color: #005CB2 !important;
}
</style>
